import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component, Inject,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser, NgIf } from "@angular/common";
import { HighchartsChartModule } from "highcharts-angular";
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import HC_solidGauge from 'highcharts/modules/solid-gauge';

if(typeof Highcharts === 'object') {
  HC_more(Highcharts);
  HC_solidGauge(Highcharts);
}

@Component({
  selector: 'test-gauge-chart',
  providers: [],
  standalone: true,
  styleUrls: ['./test-gauge-chart.scss'],
  templateUrl: './test-gauge-chart.html',
  imports: [
    NgIf,
    HighchartsChartModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestGaugeChartComponent implements OnInit, OnChanges, OnDestroy {

    @Input()
    public unit = '';

    @Input()
    public title = '';

    @Input()
    public chartTitle = '';

    @Input()
    public data: number|undefined;

    @Input()
    public dataBorg: number|undefined;

    @Input()
    public subject: Subject<any> = new Subject<any>();


  public Highcharts: typeof Highcharts = Highcharts;
  public chartId: string;
  public isBrowser: boolean;
  public chartConstructor: string = "chart";
  public chartOptions: any = {
        chart: {
          type: 'solidgauge',
          margin: [0, 0, 50, 0],
          height: 190,
          width: 180,
          style: {
              fontFamily: 'sinkin',
              fontSize: '15px',
              fontWeight: '300',
          },
        },
        title: {text: ""},
        pane: {
            size: '100%',
            startAngle: 0,
            endAngle: 360,
            background: [
              {
                backgroundColor: '#D3D3D3',
                innerRadius: '80%',
                outerRadius: '100%',
                shape: 'arc'
              },
            ]
        },
        tooltip: {
            enabled: false
        },
        yAxis: {
            min: 0,
            max: 10,
            stops: [
                [0, '#DF5353'],
                [0.5, '#DDDF0D'],
                [1, '#55BF3B']
            ],
            lineWidth: 0,
            minorTickInterval: undefined,
            tickAmount: 11,
            tickInterval: 1,
            tickLength: 20,
            tickColor: '#fff',
            tickPosition: 'inside',
            tickmarkPlacement: 'on',
            tickWidth: 2,
            zIndex: 100,
            title: {
                text: '<span style="font-family:\'sinkin\', sans-serif; text-transform: uppercase;">' + this.title + '</span>',
                style: {
                    fontSize: '15',
                    fontWeight: '300',
                },
                useHTML: true,
                x: 0,
                y: 135,
            },
            labels: {
                enabled: false,
                y: 16
            },
        },
        plotOptions: {
            solidgauge: {
                innerRadius: '80%',
                dataLabels: {
                    y: -30,
                    borderWidth: 0,
                    useHTML: true
                }
            }
        },
        credits: {
            enabled: false
        },
        lang: {
            noData: this.translator.instant('NoData'),
        },
    };

  private subscriptions: Subscription[] = [];


  constructor(
      private translator: TranslateService,
      @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.chartId = 'chart-' + Math.random().toString(36).substr(2, 9);
    this.isBrowser = isPlatformBrowser(platformId);
  }

    public ngOnInit(): void {

      this.subscriptions.push(
        this.subject.subscribe((event) => {
          if (event === 'delete') {
            this.chartOptions.series = [];
          }
        })
      );
    }

    public ngOnChanges(changes:any) {
        if (changes['data'] && null !== this.data) {
            this.addSeries();
        }
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    private addSeries() {
      const self = this;
      let formattedData = '';
      if (this.data !== undefined) {
        formattedData = parseFloat(this.data.toFixed(2)).toString();
      }

      this.chartOptions.series = [];
      this.chartOptions.series.push({
        data: [this.dataBorg],
        dataLabels: {
          format: '<div style="text-align:center">' +
            '<span style="font-family:\'sinkin\', sans-serif; font-size:40px; line-height: 40px;">' + formattedData + '</span><br/>' +
            '<span style="font-family:\'sinkin\', sans-serif; font-size:12px; font-weight: 800;">' + self.unit + '</span>' +
            '</div>',
        },
        tooltip: {
          valueSuffix: ' ' + this.unit
        },
      });
      console.log(this.chartOptions.series);
    }
}

